import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

interface BreadcrumbItem {
    label: string;
    active: boolean;
    onClick?: () => void;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => (
    <Breadcrumb style={{ marginBottom: 'var(--spacer-M)', backgroundColor: 'transparent', padding: 0 }}>
        {items.map((item, index) => (
            <BreadcrumbItem key={index} active={item.active}>
                {item.onClick && !item.active ? (
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            item.onClick?.();
                        }}
                        style={{ cursor: 'pointer', color: 'var(--appBlue)' }}
                    >
                        {item.label}
                    </a>
                ) : (
                    item.label
                )}
            </BreadcrumbItem>
        ))}
    </Breadcrumb>
);

export default Breadcrumbs;
